import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import { FormattedMessage } from 'react-intl';
import Typography from '@material-ui/core/Typography';
import ProductListItem from './products/ProductListItem';
import { withNavigation } from '../actions/navigation';

const styles = theme => ({
  drawer: {
    position:'static',
    maxWidth: 240,
    minWidth: 180,
    flexShrink: 0,
  },
  drawerPaper: {
    position:'static',
  },
  titleLink: {
    textDecoration: 'none',
  },
  drawerPaperAnchor:{
    borderRight: 'none',
  }
});

const Section = ({
  label,
  children,
}) => (
  <div>
    <Typography variant="subtitle1" style={{marginTop:24, marginLeft:14, marginBottom:14}}>
      {label}
    </Typography>
    <List>
      {children}
    </List>
  </div>
)


class MDrawer extends React.Component {
    
    render() {
      const { 
        classes, 
        products, 
        subscriptions, 
        navigateToSubscription,
        navigateToProduct,
        visible,
        currentProduct,
        specificSelectedColor,
      } = this.props;
      
      const sections = [];

      if( products.length > 0 ) {
        sections.push({
          label: products.length > 1 
            ? <FormattedMessage id='product.drawer.label.plural' />
            : <FormattedMessage id='product.drawer.label' />,
          children: products.map(product => 
              <ProductListItem 
                key={product.id} 
                product={product} 
                currentProduct={currentProduct}
                onClick={() => navigateToProduct(product)}
              />
          ),
        })
      }

      if( subscriptions.length > 0 ) {
        sections.push({
          label: subscriptions.length > 1 
            ? <FormattedMessage id='subscription.drawer.label.plural'  />
            : <FormattedMessage id='subscription.drawer.label' />,
          children: subscriptions.map(subscription => 
              <ProductListItem 
                key={subscription.id} 
                product={subscription.plan.product} 
                currentProduct={currentProduct}
                specificSelectedColor={specificSelectedColor}
                hasRedDot={(currentProduct !== subscription.plan.product.id) && subscription.warnings && subscription.warnings.length > 0}
                onClick={() => navigateToSubscription(subscription.id)}  
              />
          ),
        })
      }

      return (
        (visible === undefined || visible) &&
          <Drawer
            className={classes.drawer}
            variant="permanent"
            classes={{
                paper: classes.drawerPaper,
                paperAnchorDockedLeft: classes.drawerPaperAnchor
              }}
          >
            {
              sections.map( (section,index) => (
                <Section
                  key={index} 
                  label={section.label}>
                  {section.children}  
                </Section>
              ))
            }
          </Drawer>
        
      );
    }
  }
  
  MDrawer.propTypes = {
    classes: PropTypes.object.isRequired,
    products: PropTypes.array.isRequired,
    subscriptions: PropTypes.array.isRequired,
    navigateToProduct: PropTypes.func.isRequired,
    navigateToSubscription: PropTypes.func.isRequired,
    currentProduct: PropTypes.string,
  };
  
  export default withStyles(styles)(
    withNavigation(MDrawer)
  );


// WEBPACK FOOTER //
// ./src/components/DrawerMenu.js